export default "__VITE_ASSET__DrA2NgGy__"